import { Action, DataContainer } from '@otto-ec/tracking-bct';
import { VariationTrackingDataProvider } from './variation-tracking-data-provider';

export class EventTrackingHelper {
    constructor(private provider: VariationTrackingDataProvider) {}

    public enhance(data: DataContainer, action?: Action): { data: DataContainer; action: Action } {
        const { dataContainer: variationData, features } = this.provider.getVariationTrackingData();
        return {
            data: { ...data, ...variationData },
            action: {
                name: action?.name ?? 'click',
                features: [...(action?.features ?? []), ...features],
            },
        };
    }
}
